module.exports = __webpack_public_path__ + "img/networkError.6d5fac50.png";